import HistoryTab from "./HistoryTab";

export default HistoryTab;